
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FaceSignPopup extends Vue {
  public onCancel() {
    this.$emit("cancel");
  }

  public onConfirm() {
    this.$emit("confirm");
  }
}
